
define(
	'EideBaillyLLP.PDPExtension', [], 
	function () {

	'use strict';
	
	return  {
		mountToApp: function mountToApp (container)
		{
			/**
			* @type {ProductDetailsComponent}
			*/
			var pdp = container.getComponent('PDP');

			if (pdp)
			{
				try 
				{
					// isOpen
					pdp.addToViewContextDefinition('QuantityPricing.View', 'isOpen', 'boolean', function isOpen (context) {
						return true;
					});
				} 
				catch (e) 
				{
					console.error(e);
				}
 			}
		}
	};
});
